enum TaskPriority {
  high = "高",
  middle = "中",
  low = "低",
}
export default TaskPriority;
